/**
 * useSocket(event, handler)
 *
 * Se suscribe a un evento de Socket.IO y limpia la suscripción al desmontar.
 * El handler debe estar memorizado (useCallback) para evitar re-suscripciones.
 *
 * Uso:
 *   const onEvent = useCallback((data) => { ... }, [deps]);
 *   useSocket('event', onEvent);
 */
import { useEffect } from "react";
import socket from "../socket";

export default function useSocket(event, handler) {
  useEffect(() => {
    socket.on(event, handler);
    return () => {
      socket.off(event, handler);
    };
  }, [event, handler]);
}
